import { TReduxActions } from '../../types/redux';
import { IService } from '../../types/services';

export function pageServicesReducer(state: IService[] = [], action: TReduxActions): IService[] {
  switch (action.type) {
    default:
      return state;
  }
}
